import React from 'react'

export const CotizacionCartaFactura = React.forwardRef((props, ref) => {
  const { getQuote } = props

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  const currency = getQuote.store.company.currency.symbol

  return (
    <div ref={ref} style={{ textAlign: 'center', marginLeft: '2rem', marginRight: '2rem' }} className='ticket-modal-quotation' >
      {
        getQuote.quote_invoice.fel_hondura ? (
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontWeight: 'bolder' }}>{`Empresa: ${getQuote?.company ? getQuote.company : getQuote?.store?.company?.name}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Direccion: ${getQuote?.store?.company?.address}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`RTN: ${getQuote?.quote_invoice?.fel_hondura?.rtn}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Tienda: ${getQuote?.store?.name ? getQuote?.store?.name : getQuote?.store?.name}`}</p>
          </div>
        ) : (
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontWeight: 'bolder' }}>{`Empresa: ${getQuote?.company ? getQuote.company : getQuote?.store?.company?.name}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Direccion: ${getQuote?.store?.company?.address}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Nit: ${getQuote?.nit ? getQuote.nit : getQuote?.store?.company?.nit}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Tienda: ${getQuote?.store?.name ? getQuote?.store?.name : getQuote?.store?.name}`}</p>
            <br></br>
          </div>
        )
      }

      <br></br>
      <p>{`COTIZACIÒN`}</p>
      <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <p style={{ fontWeight: 'bolder' }}>{`Cotización No.:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Fecha:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Cliente:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Nit:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Condición:`}</p>
        </div>
        <div>
          <p>{`${getQuote?.id}`}</p>
          <p>{`${getQuote?.date}`}</p>
          <p>{`${getQuote?.client?.name}`}</p>
          <p>{`${getQuote?.client?.nit}`}</p>
          <p>{``}</p>
        </div>
        <div>
          <br></br>
          <p style={{ fontWeight: 'bolder' }}>{`Vence: ${getQuote?.expiration_date}`}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          {/* <h1>{`Imagen`}</h1> */}
        </div>
      </div>
      <table className='ticket-modal-quotation' style={{ width: '-webkit-fill-available' }}>
        <thead style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.65)', borderTop: '2px solid rgba(0, 0, 0, 0.65)' }}>
          <tr>
            <th>{`Código`}</th>
            <th>{`Producto`}</th>
            <th>{`Cantidad`}</th>
            <th>{`Dto o Rebaja`}</th>
            <th>{`Precio`}</th>
            <th>{`Total`}</th>
          </tr>
        </thead>
        <tbody>
          {getQuote?.quote_details && getQuote?.quote_details?.map((data) => (
            <tr key={data.id}>
              <td>{`${data.presentation_id}`}</td>
              <td style={{ display: 'flex', textTransform: 'none' }}>{data?.presentation?.description.substring(0, 40)}</td>
              <td>{`${data.quantity}`}</td>
              <td>{currency} {data.discount_amount ? trunc(data.discount_amount) : 0}</td>
              <td>{currency} {trunc(data?.price)}</td>
              <td>{`${currency} ${trunc(data?.sub_total)}`}</td>
            </tr>
          ))}
        </tbody>
        <div style={{ position: 'fixed', left: '5%', bottom: 0, width: '90%' }}>
          <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <p>{`Articulo Gravado`}</p>
              <p>{`Comentarios: `}</p>
            </div>
            <div style={{ display: 'flex' }}>
              <div>
                <p>{`DTO O REBAJA: `}</p>
                <p>{`EXONERADO: `}</p>
                <p>{`IMPORTE EXENTO: `}</p>
                {getQuote.store.company.country.name === 'Honduras' ? (
                  <>
                    <p>{`IMPORTE ${trunc(getQuote.quote_invoice.percentage_amount_taxed)}%: `}</p>
                    <p>{`ISV ${trunc(getQuote.quote_invoice.percentage_amount_taxed)}%: `}</p>
                    <p>{`IMPORTE 18%: `}</p>
                    <p>{`ISV 18%: `}</p>
                  </>
                ) : (
                  <>
                    <p>{`IVA ${trunc(getQuote.quote_invoice.percentage_amount_taxed)}%: `}</p>
                  </>
                )}
                <p>{`GRAN TOTAL: `}</p>
                <p>{`TOTAL: `}</p>
              </div>
              <div style={{ marginLeft: 30 }}>
                <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote?.quote_invoice?.discount_amount)} `}</p>
                <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.exonerated_amount)} `}</p>
                <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.exempt_amount)} `}</p>
                {getQuote.store.company.country.name === 'Honduras' ? (
                  <>
                    <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.value_amount_taxed)} `}</p>
                    <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.amount_iva)} `}</p>
                    <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} 0.00 `}</p>
                    <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} 0.00 `}</p>
                  </>
                ) : (
                  <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.amount_iva)} `}</p>
                )}
                {getQuote.quote_invoice.exonerated_client === 1 &&
                  <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(parseFloat(getQuote?.quote_invoice?.value_amount_taxed) + parseFloat(getQuote?.quote_invoice?.amount_iva))} `}</p>
                }
                <p>{`${getQuote?.store?.company?.currency?.symbol ? getQuote?.store?.company?.currency?.symbol : ''} ${trunc(getQuote.quote_invoice.total)} `}</p>
              </div>
            </div>
          </div>
        </div>
      </table>
    </div >
  );
});
